import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { ProjectProvider } from '../contexts/ProjectContext';
/**
 * Layout wrapper for all /project/:projectId/* routes.
 * Provides ProjectContext to all nested routes.
 */ export function ProjectLayout() {
    return /*#__PURE__*/ _jsx(ProjectProvider, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
}
